import { faWindowClose, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const ClienteHeader = ({
    customerdetails,
    editar,
    editando,
    setEditar,
    handleSubmit,
    onSubmit,
    reset,
    validarDatosFiscales,
    obtenerComboBoxSoporteTecnico,
    setShowModalEliminar,
    onOpenNotasModal,
    clientNotesCount = 0
}) => {
    const navigate = useNavigate();

    return (
        <Card className="mb-3">
            <Card.Header className="d-flex flex-between-center">
                <IconButton
                    onClick={() => navigate(-1)}
                    variant="falcon-default"
                    size="sm"
                    icon="arrow-left"
                />
                {customerdetails.bIsActive == 0 && (
                    <h1>
                        <Badge bg='danger' className='me-2'>CLIENTE ELIMINADO</Badge>
                    </h1>
                )}

                <Flex>
                    {customerdetails.bIsActive && (
                        <>
                            {!editar && (
                                <>
                                    <Link to={"/licencias/nueva/" + customerdetails.idClienteAkasia}>
                                        <IconButton
                                            variant="falcon-default"
                                            size="sm"
                                            icon="plus"
                                            transform="shrink-2"
                                            iconAlign="middle"
                                            className="d-sm-block me-2"
                                        >
                                            <span className="d-none d-xl-inline-block ms-1">Nueva licencia</span>
                                        </IconButton>
                                    </Link>

                                    <IconButton
                                        onClick={() => { validarDatosFiscales(customerdetails.idClienteAkasia); }}
                                        variant="falcon-default"
                                        size="sm"
                                        icon="shopping-cart"
                                        transform="shrink-2"
                                        iconAlign="middle"
                                        className="d-sm-block me-2"
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">Nueva orden</span>
                                    </IconButton>

                                    <IconButton
                                        onClick={() => { setEditar(true); }}
                                        variant="falcon-default"
                                        size="sm"
                                        icon="pencil-alt"
                                        transform="shrink-2"
                                        className="d-sm-block me-2"
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">Editar detalles</span>
                                    </IconButton>

                                    {onOpenNotasModal && (
                                        <IconButton
                                            onClick={onOpenNotasModal}
                                            variant="falcon-default"
                                            size="sm"
                                            icon={faStickyNote}
                                            transform="shrink-2"
                                            className="d-sm-block me-2"
                                        >
                                            <span className="d-none d-xl-inline-block ms-1">Notas del cliente</span>
                                            {clientNotesCount > 0 && (
                                                <Badge bg="success" pill className="ms-1">
                                                    {clientNotesCount}
                                                </Badge>
                                            )}
                                        </IconButton>
                                    )}
                                </>
                            )}
                            {editar && (
                                <>
                                    <IconButton
                                        onClick={() => { setEditar(false); reset(); }}
                                        className="d-sm-block me-2"
                                        variant="falcon-default"
                                        size="sm"
                                        icon={faWindowClose}
                                        transform="shrink-2"
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">Cancelar edici&oacute;n</span>
                                    </IconButton>

                                    <IconButton
                                        className="d-sm-block me-2"
                                        variant="falcon-default"
                                        transform="shrink-2"
                                        size="sm"
                                        icon="check"
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            console.log('=== Botón Guardar Cambios clickeado ===');

                                            // Llamar handleSubmit con callbacks
                                            await handleSubmit(
                                                async (data) => {
                                                    console.log('Validación exitosa, ejecutando onSubmit');
                                                    console.log('Datos capturados:', data);
                                                    await onSubmit(data);
                                                },
                                                (validationErrors) => {
                                                    console.log('Errores de validación del formulario:', validationErrors);
                                                    console.log('Cantidad de errores:', Object.keys(validationErrors).length);
                                                }
                                            )();
                                        }}
                                        disabled={editando}
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">
                                            {editando ? 'Guardando Cambios...' : 'Guardar Cambios'}
                                        </span>
                                    </IconButton>
                                </>
                            )}
                            {!editar && (
                                <>
                                    <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="edit"
                                        transform="shrink-2"
                                        iconAlign="middle"
                                        className="d-sm-block me-2"
                                        onClick={() => obtenerComboBoxSoporteTecnico()}
                                    >
                                        <span className="d-none d-xl-inline-block ms-1">Registrar Soporte T&eacute;cnico</span>
                                    </IconButton>

                                    <IconButton
                                        variant="falcon-danger"
                                        size="sm"
                                        icon="trash"
                                        transform="shrink-2"
                                        iconAlign="middle"
                                        className="d-sm-block me-2"
                                        onClick={() => { setShowModalEliminar(true) }}
                                    >
                                    </IconButton>
                                </>
                            )}
                        </>
                    )}
                    <IconButton
                        variant="falcon-default"
                        size="sm"
                        icon="print"
                        transform="shrink-2"
                        iconAlign="middle"
                        className="d-sm-block me-2"
                        onClick={() => { window.print() }}
                    >
                    </IconButton>
                </Flex>
            </Card.Header>
        </Card>
    );
};

ClienteHeader.propTypes = {
    customerdetails: PropTypes.shape({
        idClienteAkasia: PropTypes.number.isRequired,
        bIsActive: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired
    }).isRequired,
    editar: PropTypes.bool.isRequired,
    editando: PropTypes.bool.isRequired,
    setEditar: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    validarDatosFiscales: PropTypes.func.isRequired,
    obtenerComboBoxSoporteTecnico: PropTypes.func.isRequired,
    setShowModalEliminar: PropTypes.func.isRequired,
    onOpenNotasModal: PropTypes.func,
    clientNotesCount: PropTypes.number
};

export default ClienteHeader;
